import { useCallback, useMemo, memo } from 'react';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { useBoardDispatch, useBoardSelector } from '../redux/reduxHooks';
import { makeGetIsCardSelected, setCardsSelected } from '../redux/selectionSlice';
import { jsx as _jsx } from "react/jsx-runtime";
const SelectionCheckbox = ({
  cardId
}) => {
  const getIsCardSelected = useMemo(() => makeGetIsCardSelected(cardId), [cardId]);
  const isSelected = useBoardSelector(getIsCardSelected);
  const dispatch = useBoardDispatch();
  const handleChange = useCallback(({
    target: {
      checked
    }
  }) => {
    return dispatch(setCardsSelected({
      cards: [{
        cardId,
        selected: checked
      }]
    }));
  }, [dispatch, cardId]);
  return /*#__PURE__*/_jsx(Checkbox, {
    "data-test-id": `checkbox-select-card-${cardId}`,
    checked: isSelected,
    onChange: handleChange,
    onClick: evt => {
      // prevents the preview sidebar from opening when checking box
      evt.stopPropagation();
    }
  });
};
export default /*#__PURE__*/memo(SelectionCheckbox);